var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"table",class:{'is-loading': _vm.loading}},[(_vm.loading)?_c('i',{staticClass:"fa fa-spinner fa-spin table-loading"}):_vm._e(),(!_vm.loading)?[_vm._t("default")]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }